import {
    UPLOAD_PROFILE_PIC,
    UPLOAD_AADHARCARD_PIC,
    ANALYTICS_LIST,
    ANALYTICS_CHANGE_STATUS,
    ANALYTICS_ADDEDIT,
    ANALYTICS_GETONE,
    ANALYTICS_DELETE,
    LIST_DISTRICT,
    LIST_TALUKA,
    LIST_VILLAGE,
    EDUCATION_WOP_LIST,
    OCCUPATION_WOP_LIST,
    FAMILY_LIST,
    FAMILY_ADDEDIT,
    FAMILY_GETONE,
    FAMILY_DELETE,
    RELATION_WOP_LIST,
    USER_APPROVE_REJECT,
    USER_REJECT,
    USER_EXPORT,
    RESULT_EXPORT
} from "../../api/constApi";
import { authHeader, fileAuthHeader } from "./authHeader";
import { apiInstance } from "./axiosApi";


export const uploadPofilePicApi = (payload) => {
    return apiInstance.post(UPLOAD_PROFILE_PIC, payload, {
        headers: fileAuthHeader(),
    });
};
export const uploadAadharCardPicApi = (payload) => {
    return apiInstance.post(UPLOAD_AADHARCARD_PIC, payload, {
        headers: fileAuthHeader(),
    });
};

export const userAnalyticsListApi = (payload) => {
    return apiInstance.post(ANALYTICS_LIST, payload, {
        headers: authHeader(),
    });
};

export const userAnalyticsChangeStatusApi = (payload) => {
    return apiInstance.post(ANALYTICS_CHANGE_STATUS, payload, {
        headers: authHeader(),
    });
};

export const AddEditUserAnalyticsApi = (payload) => {
    return apiInstance.post(ANALYTICS_ADDEDIT, payload, {
        headers: fileAuthHeader(),
    });
};

export const GetOneUserAnalyticsApi = (payload) => {
    return apiInstance.post(ANALYTICS_GETONE, payload, {
        headers: fileAuthHeader(),
    });
};

export const UserAnalyticsDeleteApi = (payload) => {
    return apiInstance.post(ANALYTICS_DELETE, payload, {
        headers: authHeader(),
    });
};

export const GetAllDistrictApi = (payload) => {
    return apiInstance.get(LIST_DISTRICT, {
        headers: authHeader(),
        params: payload
    });
};

export const GetAllTalukaApi = (payload) => {
    return apiInstance.get(LIST_TALUKA, {
        headers: authHeader(),
        params: payload
    });
};

export const GetAllVillageApi = (payload) => {
    return apiInstance.get(LIST_VILLAGE, {
        headers: authHeader(),
        params: payload
    });
};
export const GetAllEducationApi = (payload) => {
    return apiInstance.get(EDUCATION_WOP_LIST, {
        headers: authHeader(),
        params: payload,
    });
};
export const GetAllOccupationApi = (payload) => {
    return apiInstance.get(OCCUPATION_WOP_LIST, {
        headers: authHeader(),
        params: payload,
    });
};

export const familyListApi = (payload) => {
    return apiInstance.post(FAMILY_LIST, payload, {
        headers: authHeader(),
    });
};

export const AddEditFamilyApi = (payload) => {
    return apiInstance.post(FAMILY_ADDEDIT, payload, {
        headers: authHeader(),
    });
};

export const GetOneFamilyApi = (payload) => {
    return apiInstance.post(FAMILY_GETONE, payload, {
        headers: authHeader(),
    });
};
export const familyDeleteApi = (payload) => {
    return apiInstance.post(FAMILY_DELETE, payload, {
        headers: authHeader(),
    });
};

export const GetAllRelationApi = (payload) => {
    return apiInstance.get(RELATION_WOP_LIST, {
        headers: authHeader(),
        params: payload
    });
};

export const UserApproveRejectApi = (payload) => {
    return apiInstance.post(USER_APPROVE_REJECT, payload, {
        headers: authHeader(),
    });
};

export const UserRejectApi = (payload) => {
    return apiInstance.post(USER_REJECT, payload, {
        headers: authHeader(),
    });
};

export const UserExportApi = (payload) => {
    return apiInstance.post(USER_EXPORT, payload, {
        headers: authHeader(),
    });
};

export const ResultExportApi = (payload) => {
    return apiInstance.post(RESULT_EXPORT, payload, {
        headers: authHeader(),
    });
};
